import { Box, useTheme } from "@mui/joy";
import SideBar from "../custom_elements/sideBar";
import { useContext, useEffect } from "react";
import SessionContext from "../../../store";
import UIContext from "../../../store/ui";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { SIDEBAR_WIDTH_PX } from "../../../constants/layout";

const Home = ({children}) => {
    const theme = useTheme();
    const { setSession } = useContext(SessionContext);
    const { addReferidosToMenu } = useContext(UIContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (typeof window !== 'undefined' && window.localStorage) {
            const storedSession = JSON.parse(localStorage.getItem("User"));
            if (storedSession) {
                setSession({
                    username: storedSession.username,
                    type: storedSession.type,
                    token: storedSession.token,
                    password_update_required: storedSession.password_update_required
                });
                // Referidos [#33/#34]: admin-only (referrals are an admin concern), and only when
                // this admin actually refers someone.
                if (storedSession.token && storedSession.type === 'admin') {
                    axios.get(
                        `${process.env.REACT_APP_URL_API_CRIXTO}orders/referrals`,
                        { headers: { Authorization: `Bearer ${storedSession.token}` } }
                    ).then((res) => {
                        if (res.data?.data?.isReferrer) addReferidosToMenu();
                    }).catch(() => { /* non-referrer or unreachable: leave menu unchanged */ });
                }
                navigate("/tx")
            }
            else{
                navigate("/")
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box sx={{backgroundColor: theme.vars.palette.background.body}}>
            <Box sx={{ display: "flex", maxWidth: "100vw"}}>
                <Box sx={{height: "100dvh", maxHeight: "100dvh", overflowY: "auto", position: "fixed", width: SIDEBAR_WIDTH_PX}}>
                    <SideBar />
                </Box>
                <Box display="flex" sx={{ overflowY: "auto", minHeight: "100dvh", marginLeft: SIDEBAR_WIDTH_PX }}>
                    {children}
                </Box>
            </Box>
        </Box>
    )
}

export default Home;